/* eslint-disable react/react-in-jsx-scope */
import Network from "../assets/icons/Network-Trusted-Partners.svg";
import ThoughtfulRecommendations from "../assets/icons/Thoughtful-Recommendations.svg";
import HonoringWishes from "../assets/icons/Honoring-Wishes.svg";
import SimplifyingDecisions from "../assets/icons/Simplifying-Decisions.svg";
import CompassionateSupport from "../assets/icons/Compassionate-Support.svg";
import CentralHub from "../assets/icons/Central-Hub1.svg";
import House from "../assets/media/house.jpg";
import Family from "../assets/media/family.jpg";
import Handshake from "../assets/media/handshake.jpg";
import Flowers from "../assets/media/flowers.jpg";
import Hands from "../assets/media/hands.jpg";
import Cemetery from "../assets/media/cemetery.jpg";
import Logistics from "../assets/media/logistics.jpg";
import PreneedPlanner from "../assets/media/preneed-planner.jpg";
import AgentAssistance from '../assets/media/agent-assistance.jpg'

export type HoverOverlayItem = {
  title: string;
  description: string;
  tagsTitle: string;
  tags: string[];
};

export type CarouselItem = {
  title: string;
  image: string;
  hoverOverlay?: HoverOverlayItem;
};

export const carouselItems: CarouselItem[] = [
  {
    title: "Funeral Homes",
    image: Cemetery,
    hoverOverlay: {
      title: "Grief Counselling & Support",
      description:
        "Find funeral Grief offering traditional services, cremation and memorial ceremonies",
      tagsTitle: "Common Services",
      tags: [
        "Traditional grief Services",
        "Memorial Services",
        "Graveside Services",
        "Casket & Urn Selection",
        "+7 More",
      ],
    },
  },
  {
    title: "Cemeteries & Memorial Parks",
    image: PreneedPlanner,
    hoverOverlay: {
      title: "Cemeteries & Memorial Parks",
      description:
        "Ensure every detail is handled with care, from transportation to ceremony arrangements",
      tagsTitle: "Logistics Services",
      tags: [
        "Transportation",
        "Body Preparation",
        "Hospitality Services",
        "+2 More",
      ],
    },
  },
  {
    title: "Pre-Planning & Advance Care",
    image: Logistics,
    hoverOverlay: {
      title: "Pre-Planning & Advance Care",
      description:
        "Plan ahead to ensure your wishes are honored and to ease the emotional and financial burden on loved ones.",
      tagsTitle: "Pre-Planning Includes",
      tags: [
        "Pre-Planning Packages",
        "Burial Plot",
        "Financial Planning",
        "Insurance",
        "Personal Legacy",
        "+6 More",
      ],
    },
  },
  {
    title: "Logistics & Practical Support",
    image: House,
    hoverOverlay: {
      title: "Logistics & Practical Support",
      description:
        "Ensure every detail is handled with care, from transportation to ceremony arrangements",
      tagsTitle: "Logistics Services",
      tags: [
        "Transportation",
        "Body Preparation",
        "Hospitality Services",
        "+2 More",
      ],
    },
  },
  {
    title: "Logistics & Practical Support",
    image: House,
    hoverOverlay: {
      title: "Logistics & Practical Support",
      description:
        "Ensure every detail is handled with care, from transportation to ceremony arrangements",
      tagsTitle: "Logistics Services",
      tags: [
        "Transportation",
        "Body Preparation",
        "Hospitality Services",
        "+2 More",
      ],
    },
  },
  {
    title: "Logistics & Practical Support",
    image: House,
    hoverOverlay: {
      title: "Logistics & Practical Support",
      description:
        "Ensure every detail is handled with care, from transportation to ceremony arrangements",
      tagsTitle: "Logistics Services",
      tags: [
        "Transportation",
        "Body Preparation",
        "Hospitality Services",
        "+2 More",
      ],
    },
  },
  {
    title: "Logistics & Practical Support",
    image: PreneedPlanner,
    hoverOverlay: {
      title: "Logistics & Practical Support",
      description:
        "Ensure every detail is handled with care, from transportation to ceremony arrangements",
      tagsTitle: "Logistics Services",
      tags: [
        "Transportation",
        "Body Preparation",
        "Hospitality Services",
        "+2 More",
      ],
    },
  },
  {
    title: "Logistics & Practical Support",
    image: House,
    hoverOverlay: {
      title: "Logistics & Practical Support",
      description:
        "Ensure every detail is handled with care, from transportation to ceremony arrangements",
      tagsTitle: "Logistics Services",
      tags: [
        "Transportation",
        "Body Preparation",
        "Hospitality Services",
        "+2 More",
      ],
    },
  },
];

// Hover overlay card
export const hoverOverlayItem: HoverOverlayItem = {
  title: "Grief Counselling & Support",
  description:
    "Find funeral Grief offering traditional services, cremation and memorial ceremonies",
  tagsTitle: "Common Services",
  tags: [
    "Traditional grief Services",
    "Memorial Services",
    "Graveside Services",
    "Casket & Urn Selection",
    "Grief Planning & Coordination",
    "+6 More",
  ],
};

// Static cards below carousel
export const cardData = [
  {
    icon: <img src={CentralHub} alt="Central hub icon" />,
    title: "Your Central Planning Hub",
    description:
      "Plan, track, and manage services in one place — without juggling multiple providers or conversations.",
  },
  {
    icon: <img src={Network} alt="Network icon" />,
    title: "Trusted Local Network",
    description:
      "Access verified funeral homes, cemeteries, counselors, and service partners — carefully curated.",
  },
  {
    icon: (
      <img src={ThoughtfulRecommendations} alt="Thoughtful Recommendations" />
    ),
    title: "Guided Recommendations",
    description:
      "Receive suggestions based on your needs and preferences — not generic listings.",
  },
  {
    icon: <img src={HonoringWishes} alt="Wishes icon" />,
    title: "Honoring Personal Wishes",
    description:
      "Plan services that reflect personal preferences, traditions, and priorities.",
  },
  {
    icon: <img src={CompassionateSupport} alt="Support icon" />,
    title: "Human Support",
    description:
      "Guidance is available when you need clarity or reassurance, from first steps through final arrangements.",
  },
  {
    icon: <img src={SimplifyingDecisions} alt="Simplifying Decisions icon" />,
    title: "Simplified Decision-Making ",
    description:
      "MemorialGo helps reduce uncertainty by organizing options clearly, so decisions feel manageable and informed.",
  },
];

// Steps card data
export const stepCardData = [
  {
    imageUrl: Family,
    badgeText: "STEP-1",
    title: "Share What You Need",
    subtitle:
      "Whether planning ahead or seeking immediate arrangements, answer a few simple questions to get started.",
  },
  {
    imageUrl: Handshake,
    badgeText: "STEP-2",
    title: "We Bring the Right Options to You",
    subtitle:
      "Based on location and needs, MemorialGo connects you with trusted, verified providers.",
  },
  {
    imageUrl: AgentAssistance,
    badgeText: "STEP-3",
    title: "Choose What Matters Most",
    subtitle:
      "Select services, memorials, rituals, and arrangements that feel right for you and your family.",
  },
  {
    imageUrl: Hands,
    badgeText: "STEP-4",
    title: "We Guide You Through It",
    subtitle:
      "With GRACE and a dedicated team, guidance continues from first decisions through completion.",
  },
];
